// extracted by mini-css-extract-plugin
module.exports = {"tag":"index-module__tag___D0532"};